(() => {
	function attachFilesModal(
		fileUploadService,
		$rootScope,
		imageConverter,
		randomStringGenerator,
		messageService
	) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {},
			template: `
                    <div>
                        <div id="filesModal" class=\"modal modal-files-upload modal-center fade\" data-backdrop=\"false\" data-keyboard=\"false\">
                          <div class=\"modal-dialog\">
                            <form class=\"modal-content hidden-scroll\">

                              <div class=\"modal-header pt-pb-15\">
                                <button type="button" class='close' ng-click='closeModal()'>&times;</button>
                                <h3 class=\"modal-title\">From Files<\/h3>
                              <\/div>
                              
                              <div class="modal-body flex-row section-data__wrapper" style="padding: 30px!important">
                                <div class="attachment-wrapper section-data section-data--full-lg-max"
                                     ng-class="{'flex-basis-full': allFiles.length === 1}"
                                     ng-repeat="file in allFiles | filter:id track by $index">
                                     
                                     <div class="file-type {{file.convertedType}} with-checkbox" style="width: 60px; position: absolute">
                                     <div class="checkbox-squared" style="margin-top: 6px">
                                                   <input type="checkbox" id="attached-to-mail-{{file.id}}-{{checkboxIndex}}" ng-model="file.checked"/>
                                                   <label for="attached-to-mail-{{file.id}}-{{checkboxIndex}}"></label>
                                               </div>
                                     </div>
                                                                         
                                    <table class="table-profile table-full-width">
                                        <tbody>
                                          
                                            <tr>
                                            <td class="files-wrapper">
                                                   {{file.name}}
                                                </td>
                                            </tr>
                                            <tr>
                                            <td class="files-wrapper">
                                                    Uploaded on {{file.customLastModifiedDate}}
                                                </td>
                                            </tr>
                                         
                                            <tr>
                                                <td class="files-wrapper">
                                                    {{file.convertedSize}} MB
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                              </div>

                              <div class=\"modal-footer modal-foot\">
                                <button type='submit' ng-click="addAttachment()" class=\"btn btn-success btn-lg\">Attach to Email<\/button>
                              <\/div>

                            <\/form>
                          <\/div>
                        <\/div>
                        <div class='modal-link-editor__background'><\/div>
                    <\/div>
            `,
			link(scope) {
				$(document).on('shown.bs.modal', '#filesModal', () => {
					$('sendContactEmailModal')
						.find('input')
						.blur()
						.find('textarea')
						.blur();
				});

				scope.checkboxIndex = randomStringGenerator.getMixedString();

				scope.$on('addedFileEvent', () => {
					scope.allFiles = fileUploadService.getFiles();
					$rootScope.uploadedFiles = scope.allFiles.length;
				});

				scope.$on('removedData', event => {
					scope.allFiles = fileUploadService.getFiles();
					$rootScope.uploadedFiles = scope.allFiles.length;
				});

				const maxMb = 10; // 10 Mb
				const maxSize = maxMb * 1000 * 1024;
				const monthNames = [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December'
				];

				angular.forEach(scope.allFiles, file => {
					const tmpDate = new Date(file.cratedTs);
					file.customLastModifiedDate = `${tmpDate.getDate()} ${
						monthNames[tmpDate.getMonth()]
					} ${tmpDate.getFullYear()}`;
					file.convertedType = imageConverter.getFileClass(file.name);
					file.convertedSize = (parseInt(file.bytesSize) / 1024 ** 2).toFixed(
						2
					); // convert from bytes to MB
					file.fromJobController = true;
				});
				scope.checkedFiles = [];
				scope.testFiles = [];

				scope.closeModal = function() {
					switchModal();
				};

				scope.addAttachment = () => {
					let checked = true;
					scope.checkedFiles.attachments = scope.allFiles.filter(
						file => file.checked
					);

					for (let i = 0; i < scope.checkedFiles.attachments.length; i++) {
						if (scope.checkedFiles.attachments[i].bytesSize >= maxSize) {
							messageService.showToaster('w_0', 'attachments');
							checked = false;
							return false;
						}
					}

					if (checked === true) {
						scope.$emit('checkedFiles', scope.checkedFiles);
						switchModal();
						scope.allFiles.forEach(file => (file.checked = ''));
					}
				};

				function switchModal() {
					$('.in.modal-files-upload')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							if ($('.in.modal').length > 0) {
								document.body.classList.add('modal-open');
								$('.modal.in:not(.modal-link-editor)')
									.children('.modal-dialog')
									.css({ overflow: '' });
							}

							$(this).off('hidden.bs.modal');
							$('.modal.in:not(.modal-files-upload)')
								.children('.modal-dialog')
								.css({ overflow: '' });
						});
				}
			}
		};
	}

	attachFilesModal.$inject = [
		'fileUploadService',
		'$rootScope',
		'imageConverter',
		'randomStringGenerator',
		'messageService'
	];

	angular.module('main').directive('attachFilesModal', attachFilesModal);
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/attachFilesModal.js